import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import PreventiveAction from "./component/PreventiveAction";
import RootCause from "./component/RootCause";
import PreventiveActionsList from "./component/PreventiveActionsList";
// import ConfirmationModal from "./component/ConfirmationModal"; // 🚫 not needed now
import {
  getIncidentById,
  generatePreviewReportForIncident, // 👈 new action for preview
  redirectToIncidentList,
} from "actions";

const CAPA_Tab = ({
  incidentId,
  setIncidentId,
  previousData,
  setPreviousData,
  onNext,
  onBack,
  loadFromBack,
  setLoadFromBack,
  goToFinalReport,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const session = useSelector((state) => state.session);
  const [activeKey, setActiveKey] = useState("PreventiveActions");
  const [accessibleTabs, setAccessibleTabs] = useState([]);
  const [isFinalReportGenerated, setIsFinalReportGenerated] = useState(false);
  // const [showConfirmationModal, setShowConfirmationModal] = useState(false); // 🚫 not needed

  useEffect(() => {
    if (previousData.status === "final_report") {
      setIsFinalReportGenerated(true);

      setActiveKey("PreventiveActions");
      setAccessibleTabs([
        { key: "PreventiveActions", title: "Preventive Actions" },
        { key: "Root Cause Analysis", title: "Root Cause Analysis" },
      ]);
    } else if (location.pathname === "/scopeIncident/edit") {
      setActiveKey("Root Cause Analysis");
      setAccessibleTabs([
        { key: "Root Cause Analysis", title: "Root Cause Analysis" },
        { key: "Add Preventive Actions", title: "Add Preventive Actions" },
      ]);
    } else {
      setAccessibleTabs([
        { key: "PreventiveActions", title: "Preventive Actions" },
        { key: "Root Cause Analysis", title: "Root Cause Analysis" },
        { key: "Add Preventive Actions", title: "Add Preventive Actions" },
      ]);
    }
  }, [previousData]);

  useEffect(() => {
    if (incidentId) {
      dispatch(getIncidentById(incidentId, "update")).then((action) => {
        const data = action?.payload || action;
        if (data) {
          setPreviousData(data);
        }
      });
    }
  }, [incidentId, dispatch]);

  const goToNextTab = (targetKey) => {
    if (targetKey) {
      setActiveKey(targetKey);
      return;
    }
    const currentIndex = accessibleTabs.findIndex(
      (tab) => tab.key === activeKey
    );
    if (currentIndex < accessibleTabs.length - 1) {
      setActiveKey(accessibleTabs[currentIndex + 1].key);
    }
  };

  const goToPreviousTab = () => {
    const currentIndex = accessibleTabs.findIndex(
      (tab) => tab.key === activeKey
    );
    if (currentIndex > 0) {
      setLoadFromBack(true);
      setActiveKey(accessibleTabs[currentIndex - 1].key);
    } else {
      if (onBack) onBack();
    }
  };

  // const generateFinalReport = () => {
  //   dispatch(
  //     generateFinalReportForIncident(
  //       incidentId,
  //       session.current_page_permissions.object_id
  //     )
  //   );
  // }; // 🚫 moved to FinalReportTab

  const generatePreviewReport = () => {
    dispatch(
      generatePreviewReportForIncident(
        incidentId,
        session.current_page_permissions.object_id
      )
    ).then((res) => {
      if (res?.data?.error) {
        return; // stop navigation
      }

      if (goToFinalReport) {
        goToFinalReport();
      }
    });
  };

  return (
    <>
      <div className="capa-content">
        <Tabs activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
          {/* {(location.pathname === "/incidentForm/edit" || isFinalReportGenerated) && (
            <Tab eventKey="PreventiveActions" title="Preventive Actions">
              <PreventiveAction
                incidentId={previousData?.id}
                setIncidentId={setIncidentId}
                goToNextTab={goToNextTab}
                goToPreviousTab={goToPreviousTab}
              />
            </Tab>
          )} */}

          <Tab eventKey="Root Cause Analysis" title="Root Cause Analysis">
            <RootCause
              incidentId={previousData?.id}
              setIncidentId={setIncidentId}
              previousData={previousData}
              goToNextTab={goToNextTab}
              goToPreviousTab={goToPreviousTab}
              isFinalReportGenerated={isFinalReportGenerated}
            />
          </Tab>

          {!isFinalReportGenerated && (
            <Tab
              eventKey="Add Preventive Actions"
              title="Add Preventive Actions"
            >
              <PreventiveActionsList
                incidentId={previousData?.id}
                incidentTimezone={previousData?.incident_timezone}
                setIncidentId={setIncidentId}
                previousData={previousData}
                onNext={onNext}
                onBack={onBack}
                loadFromBack={loadFromBack}
                setLoadFromBack={setLoadFromBack}
                goToNextTab={goToNextTab}
                goToPreviousTab={goToPreviousTab}
              />
            </Tab>
          )}
        </Tabs>

        {location.pathname === "/incidentForm/edit" &&
          (!isFinalReportGenerated ? (
            <div className="d-flex justify-content-start gap-3 m-3">
              <button className="c-b-btn" onClick={goToPreviousTab}>
                <img
                  className="me-2"
                  src="/assets/images/back-arrow.svg"
                  alt="Back"
                />
                Back
              </button>
              <button className="n-u-btn" onClick={generatePreviewReport}>
                Preview Report{" "}
                <img
                  className="ms-2"
                  src="/assets/images/next-icon.svg"
                  alt="Next"
                />
              </button>
            </div>
          ) : (
            <div className="d-flex justify-content-start gap-3 m-3">
              <button
                className="c-b-btn"
                onClick={() => {
                  dispatch(redirectToIncidentList());
                }}
              >
                Back To List
              </button>
            </div>
          ))}

        {/* <ConfirmationModal
          show={showConfirmationModal}
          handleClose={() => setShowConfirmationModal(false)}
          handleConfirm={generateFinalReport}
          title="Generate Final Report"
          message="Are you sure you want to generate the final report? This action cannot be undone."
        /> */}
      </div>

      {/* <div className="mt-3">
        <button
          className="c-b-btn"
          onClick={() => {
            dispatch(redirectToIncidentList());
          }}
        >
          Back To List
        </button>
      </div> */}
    </>
  );
};

export default CAPA_Tab;
